<!-- src/components/layout/BrandLogo.vue -->
<template>
  <div class="brand-logo" :class="{ 'brand-logo-small': small }">
    <div class="logo-container">
      <img 
        :src="require('@/assets/logo.png')" 
        :alt="appName"
        class="logo-image"
      />
    </div>
    <div v-if="showText" class="logo-text">
      <div class="name">Katherine Luzuriaga</div>
      <div class="specialty">ORTODONCIA</div>
    </div>
  </div>
</template>
  
<script>
import { mapState } from 'vuex';
  
export default {
  name: 'BrandLogo',
  props: {
    small: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      appName: state => state.appName
    })
  }
};
</script>
  
<style scoped>
.brand-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 8px 0;
  margin-right: 20px;
}

  
.logo-image {
  height: 50px;
  width: auto;
  margin-right: 10px;
  object-fit: contain;
}
  
.brand-logo-small .logo-image {
  height: 40px;
}
  
.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}
  
.name {
  font-size: 1.1rem;
  font-weight: 400;
  color: white;
}
  
.specialty {
  font-size: 0.75rem;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.9);
}
  
.brand-logo-small .name {
  font-size: 0.9rem;
}
  
.brand-logo-small .specialty {
  font-size: 0.65rem;
}
</style>